(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mr-collection-editorial"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('mr-collection-editorial')) {

 customElements.define('mr-collection-editorial', class extends HTMLElement {

  connectedCallback() {

   this.track = this.querySelector('.mr-track');

   if (!this.track || this.controller) return;

   this.controller = new AbortController();

   const options = { signal:this.controller.signal };

   this.update = () => {

    const max = this.track.scrollWidth - this.track.clientWidth;

    const pos = Math.abs(this.track.scrollLeft);

    this.querySelectorAll('[data-step]').forEach(b => b.disabled = Number(b.dataset.step) < 0 ? pos < 2 : pos >= max - 2);

   };

   this.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => {

    const card = this.track.querySelector('.mr-card');

    if (!card) return;

    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;

    const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;

    this.track.scrollBy({left:(card.getBoundingClientRect().width + gap) * Number(b.dataset.step) * rtl, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});

   }, options));

   this.track.addEventListener('scroll', this.update, {...options, passive:true});

   this.observer = new ResizeObserver(this.update);

   this.observer.observe(this.track);

   this.setAttribute('data-ready','');

   this.update();

  }

  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }

 });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-format-comparison"] && !Shopify.designMode) return;
  try {
    
function initMrComparisons(scope){
 scope.querySelectorAll('.mr-compare:not([data-ready])').forEach(root=>{
  const heads=[...root.querySelectorAll('thead [data-mc-id]')];const ids=heads.map(x=>x.dataset.mcId);const current=heads.findIndex(x=>x.dataset.mcCurrent==='true');if(current<0)return;
  const switcher=root.querySelector('.mr-compare__switch');const select=switcher?.querySelector('select');
  let visible=ids.slice(Math.max(0,Math.min(current-1,ids.length-3)),Math.max(0,Math.min(current-1,ids.length-3))+3);
  let replaceId=[...visible].reverse().find(id=>id!==ids[current]);
  function draw(){root.querySelectorAll('[data-mc-id]').forEach(x=>{x.hidden=!visible.includes(x.dataset.mcId)});root.querySelectorAll('[colspan]').forEach(x=>x.colSpan=visible.length);if(select){[...select.options].forEach(o=>{o.disabled=visible.includes(o.value)&&o.value!==replaceId})}}
  if(ids.length>3){switcher.hidden=false;select.value=replaceId;select.addEventListener('change',()=>{visible=visible.map(id=>id===replaceId?select.value:id);replaceId=select.value;visible.sort((a,b)=>ids.indexOf(a)-ids.indexOf(b));draw()})}else{visible=ids}
  root.dataset.ready='true';draw();
 });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initMrComparisons(document))}else{initMrComparisons(document)}
document.addEventListener('shopify:section:load',event=>initMrComparisons(event.target));

  } catch(e) { console.error(e); }
})();
})();
